import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
export interface topBannerPage {
  topbannerData: [] | null | any;
 topbannertotalPage: number | null;
  topbannerCurrentPage: number | null;
  topbannertotalRecord: number | null;
}
const initialState: topBannerPage = {
  topbannerData: null,
  topbannerCurrentPage: null,
  topbannertotalPage: null,
  topbannertotalRecord: null
};
export const topbannerSlice = createSlice({
  name: 'topbanner',
  initialState,
  reducers: {
    settopbanner: (state, action) => {
      state.topbannerData = action.payload;
      state.topbannerCurrentPage = action.payload.currentPage;
      state.topbannertotalPage = action.payload.totalPages;
      state.topbannertotalRecord = action.payload.totalRecords;
    },
    reset: (state) => {
      state = initialState;
    }
  }
});
export const { settopbanner } = topbannerSlice.actions;
export const gettopbanner = (state: RootState) =>
  state.topbanner.topbannerData;
export default topbannerSlice.reducer;
